import { t } from '@fetmode/i18n';

/** Viewers (total minus spies) plus a spy count when anyone is spying. */
export function formatWatchingLabel(viewerCount: number, spyCount: number): string {
  const spies = Math.max(0, spyCount);
  const floor = Math.max(0, viewerCount - spies);
  if (spies > 0) {
    return t('common.show.watchingWithSpies')
      .replace('{{viewers}}', String(floor))
      .replace('{{spies}}', String(spies));
  }
  return t('common.show.watching').replace('{{count}}', String(viewerCount));
}
